export default __webpack_public_path__ + "static/media/challenge-sample.c8523284.webp";